import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-66305535"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "layout"
};
const _hoisted_2 = ["innerHTML"];
const _hoisted_3 = {
  class: "activebar-bottom"
};
const _hoisted_4 = {
  class: "activebar-user"
};
import UserAvatar from "@/components/UserAvatar.vue";
import Logo from "./components/Logo.vue";
// import Menu from "./components/Menu.vue";
import { computed, getCurrentInstance, nextTick, onMounted, reactive, ref, toRaw, watch } from "vue";
import router from "@/router";
import { useRoute } from "vue-router";
import { useStore } from "vuex";
import Notice from "@/components/Notice.vue";

//vue3用这个来代替this

export default {
  __name: 'Layout',
  setup(__props) {
    // import Tel from "@/components/Tel.vue";
    // import Qr from "@/components/Qr.vue";
    const proxy = getCurrentInstance();

    // 获取当前路由信息
    const route = useRoute();
    const {
      meta,
      path
    } = route;
    const store = useStore();
    const routes = store.state.addRoutes;
    // const currentPath = JSON.parse(localStorage.getItem('MENU_STATE'))

    const menuList = ref([]);
    const childrenMenuList = ref({});
    const openeds = ref([]);

    // 过滤隐藏的菜单
    const filteredList = computed(() => {
      return store.state.addRoutes.filter(item => item.meta.hidden != true);
    });
    menuList.value = store.state.addRoutes;

    // 默认一级菜单选中状态
    const activePath = ref("/workbench");
    watch(() => route.path, newValue => {
      // 地址栏路由改变时，重新给一级菜单点亮状态
      var path = newValue.match(/\/[^\/]+/);
      localStorage.setItem("MENU_STATE", JSON.stringify(path[0]));
      activePath.value = path[0];
      //二级菜单点亮状态
      nextTick(() => {
        getChildrenMenu();
      });
    }, {
      immediate: true
    });

    // 一级菜单激活回调
    const menuSelect = (index, path) => {
      localStorage.setItem("MENU_STATE", JSON.stringify(index));
      getChildrenMenu();
    };
    onMounted(() => {
      // 手动刷新浏览器时，重新给一级菜单点亮状态
      activePath.value = JSON.parse(localStorage.getItem("MENU_STATE"));
      getChildrenMenu();
    });

    // 取出二级菜单
    const getChildrenMenu = () => {
      // const menu = menuList.value.filter(
      //   (item) => item.name === JSON.parse(localStorage.getItem("MENU_STATE"))
      // );

      const menu = filteredList.value.filter(item => item.name === JSON.parse(localStorage.getItem("MENU_STATE")));
      if (menu[0] !== undefined) {
        const children = menu[0]["children"];
        // 默认展开所有菜单
        childrenMenuList.value = children;
        openeds.value = children.map(item => item.path);
      } else {
        childrenMenuList.value = [];
        openeds.value = "";
      }
      // const children = menu[0]["children"];

      // 默认展开所有菜单
      // childrenMenuList.value = children;
      // openeds.value = children.map((item) => item.path);
    };

    return (_ctx, _cache) => {
      const _component_el_menu_item = _resolveComponent("el-menu-item");
      const _component_el_menu = _resolveComponent("el-menu");
      const _component_el_aside = _resolveComponent("el-aside");
      const _component_el_sub_menu = _resolveComponent("el-sub-menu");
      const _component_router_view = _resolveComponent("router-view");
      const _component_el_main = _resolveComponent("el-main");
      const _component_el_container = _resolveComponent("el-container");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_container, null, {
        default: _withCtx(() => [_createVNode(_component_el_aside, {
          class: "aside-first",
          width: "70px"
        }, {
          default: _withCtx(() => [_createVNode(Logo), _createVNode(_component_el_menu, {
            router: "",
            "default-active": activePath.value,
            class: "el-menu-vertical-demo",
            onSelect: menuSelect
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredList), (item, index) => {
              return _openBlock(), _createBlock(_component_el_menu_item, {
                key: index,
                index: item.path,
                "show-timeout": 0,
                "hide-timeout": 0
              }, {
                default: _withCtx(() => [_createElementVNode("i", {
                  class: "iconfont",
                  innerHTML: item.meta.icon
                }, null, 8, _hoisted_2), _createElementVNode("span", null, _toDisplayString(item.meta.title), 1)]),
                _: 2
              }, 1032, ["index"]);
            }), 128))]),
            _: 1
          }, 8, ["default-active"]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(UserAvatar)])])]),
          _: 1
        }), childrenMenuList.value !== undefined && childrenMenuList.value != null && childrenMenuList.value.length > 0 ? (_openBlock(), _createBlock(_component_el_aside, {
          key: 0,
          class: "aside-second",
          width: "160px"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_menu, {
            router: "",
            "default-active": _unref(router).currentRoute.value.fullPath,
            "default-openeds": openeds.value
          }, {
            default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childrenMenuList.value, item => {
              return _openBlock(), _createBlock(_component_el_sub_menu, {
                key: item.name,
                index: item.path
              }, {
                title: _withCtx(() => [_createElementVNode("span", null, _toDisplayString(item.meta.title), 1)]),
                default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.children, menu => {
                  return _openBlock(), _createBlock(_component_el_menu_item, {
                    key: menu.name,
                    index: menu.path
                  }, {
                    default: _withCtx(() => [_createTextVNode(_toDisplayString(menu.meta.title), 1)]),
                    _: 2
                  }, 1032, ["index"]);
                }), 128))]),
                _: 2
              }, 1032, ["index"]);
            }), 128))]),
            _: 1
          }, 8, ["default-active", "default-openeds"])]),
          _: 1
        })) : _createCommentVNode("", true), _createVNode(_component_el_container, null, {
          default: _withCtx(() => [_createVNode(_component_el_main, null, {
            default: _withCtx(() => [_createVNode(_component_router_view)]),
            _: 1
          })]),
          _: 1
        })]),
        _: 1
      })]);
    };
  }
};